// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__2LhDP","loader":"loader_loader__3Qpcv","logo":"loader_logo__3tZ_t"};